import type { ResidencyProfile } from "../types";

const LABEL_NOT_US_RESIDENT = "Not a resident of US";

const getUsResidenceState = (
  isEntity: boolean,
  profile: ResidencyProfile,
  addressState?: string,
): string | undefined => {
  const {
    isUsPerson,
    isUsCitizen,
    residenceState,
    hasOtherUsResidenceState,
  } = profile;

  const computedResidenceState = hasOtherUsResidenceState
    ? residenceState
    : addressState;

  if (isEntity) {
    return computedResidenceState;
  }

  if (isUsCitizen) {
    return computedResidenceState;
  }

  if (!isUsPerson) {
    return LABEL_NOT_US_RESIDENT;
  }

  return computedResidenceState;
};

export default getUsResidenceState;
